var map = {
	"./Conquest.webp": 5418,
	"./alan.webp": 6474,
	"./battle-beast.webp": 3372,
	"./bayek.png": 8842,
	"./dante.webp": 3216,
	"./deadpool.png": 7920,
	"./freddy.png": 2994,
	"./invincible.webp": 9205,
	"./isaac.png": 1299,
	"./jeffy.jpeg": 7843,
	"./lobo.webp": 5230,
	"./loki.png": 7243,
	"./magik.png": 6267,
	"./mileena.webp": 7685,
	"./naked-snake.png": 2232,
	"./sam.webp": 7303,
	"./shadowheart.png": 5298,
	"./torch.png": 2644
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6379;